import z from "zod";

export enum EditorModes {
    schematic = "schematic",
    code = "code",
    pcb = "pcb",
    files = "files",
    nets = "nets",
    components = "components",
    bom = "bom",
    pins = "pins",
    symbol = "symbol",
    blockDiagram = "block-diagram",
}
export const EditorModesSchema = z.nativeEnum(EditorModes);

export enum CameraMode {
    two_d = "two_d",
    three_d = "three_d",
}

export type InternalTabsState = {
    CLI: boolean;
    prompt: boolean;
    CAL: boolean;
};
